import { Component, Input, OnInit } from '@angular/core';
import { Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ComplementaryResourcesProgress } from 'src/app/models/career-plans';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-complementary-resource-card',
  templateUrl: './complementary-resource-card.component.html',
  styleUrls: ['./complementary-resource-card.component.scss'],
})
export class ComplementaryResourceCardComponent implements OnInit {
  @Input()
  resource: ComplementaryResourcesProgress;

  @Input()
  levelId: string;

  completionLabel: string;

  constructor(
    private router: Router,
    private localeService: LocaleService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.resolveCompletionLabel();
  }

  navigateToResource() {
    const params: Params = {
      limit: 24,
      offset: 0,
      order: 'fechaModifica_dt:desc',
      title: this.translate.instant('user.careerplans.complementary.title', {
        hours: this.resource.hoursToComplete,
      }),
      careerPlanLevelId: this.levelId,
      showReturnButton: true,
      hideButtonsSideMenu: true,
      originPage: '/user/career-plans'
    };
    this.router.navigate(['/results'], { queryParams: params });
  }

  private resolveCompletionLabel() {
    this.completionLabel =
      this.resource.progress === 100
        ? this.localeService.instant('user.careerplans.status.completed')
        : this.localeService.instant('user.careerplans.status.checking');
  }
}
